import { render, staticRenderFns } from "./List-empresa.vue?vue&type=template&id=16f66992&"
import script from "./List-empresa.vue?vue&type=script&lang=js&"
export * from "./List-empresa.vue?vue&type=script&lang=js&"
import style0 from "./List-empresa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports